// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper-element-bottom{grid-template-columns:1fr 1fr;grid-gap:10px;margin-top:15px}.wrapper-element-bottom>div:last-child{text-align:right}.wrapper-element-bottom .el-link{display:inline-block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
